import { Component, DestroyRef, inject, OnInit } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MakersiteService } from '@services/makersite.service';
import { ToastrService } from '@services/toaster.service';
import { Router } from '@angular/router';
import { InviteTeamComponent } from '../invite-team/invite-team.component';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { ButtonComponent } from '@mds/ui';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-create-team',
  standalone: true,
  imports: [MatDialogModule, ReactiveFormsModule, FormsModule, InviteTeamComponent, MdsIconsModule, MatFormFieldModule, ButtonComponent, MatInputModule],
  templateUrl: './create-team.component.html',
  styleUrls: ['./create-team.component.scss']
})
export class CreateTeamComponent implements OnInit {
  step = 1;
  nameControl = new FormControl(
    '',
    [Validators.required,
      Validators.pattern(/^[a-zA-Z0-9-_]+$/)]
  );
  available = true;
  teamInfo: any;
  invitationCount = [
    {
      inviteEmail: '',
      inviteRid: '',
      fieldName: 'input_0'
    }, {
      inviteEmail: '',
      inviteRid: '',
      fieldName: 'input_1'
    },
    {
      inviteEmail: '',
      inviteRid: '',
      fieldName: 'input_2'
    }];

  icons = MdsIcon;
  public dialogRef = inject(MatDialogRef<CreateTeamComponent>);
  private makersiteService = inject(MakersiteService);
  private toastrService = inject(ToastrService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  get getNewTeamURL() {
    return `https://${this.nameControl.getRawValue()}.makersite.app/login`;
  }

  ngOnInit(): void {
    this.nameControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((name: string) => {
        if (this.nameControl.valid) {
          this.available = true;
          this.makersiteService.checkTeamNameAvailability(name).subscribe({
            next: (res: any) => {
              this.available = !!res.is_available;
            },
            error: () => {
              this.available = false;
            }
          });
        }
      });
  }

  createTeamsite(): void {
    if (this.nameControl.invalid) {
      return;
    }
    this.makersiteService.addTeam({ name: this.nameControl.getRawValue() })
      .subscribe((res: any) => {
        this.teamInfo = {
          team_rid: res.rid,
          team_name: this.nameControl.getRawValue()
        };
        localStorage.setItem('team_info', JSON.stringify(this.teamInfo));
        this.nextStep();
      });
  }

  nextStep() {
    this.step++;
  }

  addInvitations() {
    const obj = {
      inviteEmail: '',
      inviteRid: '',
      fieldName: `input_${this.invitationCount.length}`
    };
    this.invitationCount.push(obj);
  }

  skipInvitations(): void {
    this.closeDialog();
  }

  sendInvitations() {
    const invitations: any = {
      to_email: [],
      to_user: [],
      shared_resource: `${this.teamInfo.team_name}.makersite.app`,
      shared_resource_rid: this.teamInfo.team_rid,
      message: `<p> We would like you to join our team <b>${this.teamInfo.team_name}</b> on makersite </p>`
    };
    invitations.rid = this.teamInfo.team_rid;
    this.invitationCount.forEach((el) => {
      if (el.inviteRid) {
        invitations.to_user.push(el.inviteRid);
      } else if (el.inviteEmail) {
        invitations.to_email.push(el.inviteEmail);
      }
    });
    this.makersiteService.sendInvition(invitations, invitations.rid).subscribe((res) => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
